import React from 'react';
import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import ReportingTypeList from './ReportingTypeList';

const ReportingTypes = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Derechos de Agua', icon: 'icon-droplets' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Tipos de Reportabilidad' links={breadcrumbLinks} icon={'icon-layout-list'} />
					<ReportingTypeList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default ReportingTypes;
